<script>
import { mapGetters } from "vuex";

export default {
  name: "manage-pricing-table",
  data: () => ({
    priceTable: [],
    newTitle: "",
    newDescription: "",
    newPrice: 10,
  }),
  computed: {
    ...mapGetters("shop", ["loading", "shop"]),
  },
  methods: {
    onAdd() {
      this.priceTable.push({
        title: this.newTitle,
        description: this.newDescription,
        fee: this.newPrice,
      });
      this.newTitle = "";
      this.newDescription = "";
      this.newPrice = 10;
    },
    onShow() {
      this.priceTable = [...this.shop.delivery.priceTable];
    },
    onSave() {
      this.$emit("save", this.priceTable);
      this.$bvModal.hide("pricing-table-modal");
    },
    onRemove(index) {
      this.priceTable.splice(index, 1);
    },
  },
};
</script>

<template>
  <b-modal
    id="pricing-table-modal"
    size="lg"
    hide-footer
    title="Manage Pricing Table"
    @show="onShow"
  >
    <b-form ref="tableForm" @submit.prevent="onSave">
      <b-row>
        <b-col cols="4">Title</b-col>
        <b-col cols="4">Description</b-col>
        <b-col cols="3">Pricing</b-col>
        <b-col cols="1" />
      </b-row>
      <b-row v-for="(price, index) of priceTable" :key="price.title">
        <b-col cols="4">
          <b-textarea
            required
            disabled
            placeholder="Enter title for delivery option"
            v-model="price.title"
          />
        </b-col>
        <b-col cols="4" class="pb-2">
          <b-textarea
            disabled
            required
            placeholder="Enter a description that explains your customer what this option is about"
            v-model="price.description"
          />
        </b-col>
        <b-col cols="3">
          <b-input-group prepend="$">
            <b-form-input disabled required type="number" v-model="price.fee" />
          </b-input-group>
        </b-col>
        <b-col cols="1">
          <b-button variant="danger" @click="onRemove(index)" type="button">
            <i class="fas fa-trash" />
          </b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="onAdd" @click.stop>
        <b-row>
          <b-col cols="4">
            <b-textarea
              placeholder="Enter title for delivery option"
              required
              type="text"
              v-model="newTitle"
            />
          </b-col>
          <b-col cols="4" class="pb-2">
            <b-textarea
              placeholder="Enter a description that explains your customer what this option is about"
              required
              v-model="newDescription"
            />
          </b-col>
          <b-col cols="3">
            <b-input-group prepend="$">
              <b-form-input
                placeholder="Price for this delivery service"
                required
                type="number"
                step="0.05"
                v-model="newPrice"
              />
            </b-input-group>
          </b-col>
          <b-col cols="1">
            <b-button type="submit" variant="success">
              <i class="fa fa-plus" />
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <b-row>
        <b-col>
          <b-button class="mr-2" @click="$bvModal.hide('pricing-table-modal')">
            Cancel
          </b-button>
          <b-button
            variant="primary"
            type="submit"
            :disabled="priceTable.length < 1"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<style scoped></style>
